/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateSurveyEmailContentDto
 */
export interface CreateUpdateSurveyEmailContentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyEmailContentDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyEmailContentDto
     */
    emailSubjectEn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyEmailContentDto
     */
    emailBody?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateSurveyEmailContentDto
     */
    emailBodyEn?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateSurveyEmailContentDto interface.
 */
export function instanceOfCreateUpdateSurveyEmailContentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUpdateSurveyEmailContentDtoFromJSON(json: any): CreateUpdateSurveyEmailContentDto {
    return CreateUpdateSurveyEmailContentDtoFromJSONTyped(json, false);
}

export function CreateUpdateSurveyEmailContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateSurveyEmailContentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'emailSubjectEn': !exists(json, 'emailSubjectEn') ? undefined : json['emailSubjectEn'],
        'emailBody': !exists(json, 'emailBody') ? undefined : json['emailBody'],
        'emailBodyEn': !exists(json, 'emailBodyEn') ? undefined : json['emailBodyEn'],
    };
}

export function CreateUpdateSurveyEmailContentDtoToJSON(value?: CreateUpdateSurveyEmailContentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailSubject': value.emailSubject,
        'emailSubjectEn': value.emailSubjectEn,
        'emailBody': value.emailBody,
        'emailBodyEn': value.emailBodyEn,
    };
}

